import * as React from 'react';
import { Resolution } from '../../data/Resolution';
import styled from 'styled-components';
import { getCSSVarValue } from '../../utils';

const SIZE = 32;
const MIN_SCALE = 0.5;
const MIN_SIDE = 720;
const MAX_SIZE = 1920;

interface Props {
  value: Resolution;
  selected: boolean;
}

const Wrapper = styled.div`
  width: ${SIZE}px;
  height: ${SIZE}px;
  margin-right: 10px;
`;

export default class extends React.Component<Props> {
  canvas = React.createRef<HTMLCanvasElement>();

  componentDidMount() {
    if (!this.canvas.current) {
      return;
    }
    // draw canvas
    const { width, height } = this.props.value;
    const ctx = this.canvas.current.getContext('2d')!;
    if (width === 0 && height === 0) {
      // any
      this.drawResolution(ctx, 1920, 1080);
      this.drawResolution(ctx, 1080, 1920);
    } else {
      this.drawResolution(ctx, width, height);
    }
  }

  drawResolution = (
    ctx: CanvasRenderingContext2D,
    resW: number,
    resH: number
  ) => {
    const ratio = resW / resH;
    let width: number;
    let height: number;

    if (ratio > 1) {
      // wide
      width = SIZE;
      height = SIZE / ratio;
    } else {
      height = SIZE;
      width = SIZE * ratio;
    }

    let longestSide = Math.min(
      MAX_SIZE,
      Math.max(Math.max(resW, resH), MIN_SIDE)
    ); // length between 720 and 1920
    let scale =
      MIN_SCALE +
      ((1 - MIN_SCALE) * (longestSide - MIN_SIDE)) / (MAX_SIZE - MIN_SIDE);

    width = Math.round(width * scale);
    height = Math.round(height * scale);

    const x = Math.round((SIZE - width) * 0.5);
    const y = Math.round((SIZE - height) * 0.5);
    ctx.strokeStyle = this.props.selected
      ? getCSSVarValue('--accent-color-lighter')
      : getCSSVarValue('--primary-text-color');
    ctx.lineWidth = 1;
    ctx.strokeRect(x + 0.5, y + 0.5, width - 1, height - 1);
  };

  render() {
    return (
      <Wrapper>
        <canvas ref={this.canvas} width={SIZE} height={SIZE} />
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/showcase/components/ResolutionIcon.tsx